/**
 * Mapping of Company codes to Planning Company codes
 * Used for copy functionality in Forecast Input grid to convert company codes to planning company format
 * Source: companyplan.xlsx
 */
export const COMPANY_TO_PLANNING_COMPANY_MAPPING: Record<string, string> = {
  ZZ: 'UK_P',
  AE: 'US_P',
  DL: 'K5_P',
  BG03: 'US_P',
  BG04: 'US_P',
  BG20: 'US_P',
  NB: 'ADEGP_P',
  C1: 'C1_P',
  '67': 'EG_P',
  B629: 'EG_P',
  B820: 'EG_P',
  BAEG: 'EG_P',
  BG38: 'EG_P',
  EX: 'EX_P',
  KQ: 'LN_P',
  LN: 'LN_P',
  LV: 'LN_P',
  MC: 'LN_P',
  NJ: 'LN_P',
  PX: 'LN_P',
  PZ: 'LN_P',
  QC: 'LN_P',
  B694: 'US_P',
  B429: 'MA_P',
  B497: 'MA_P',
  B891: 'MA_P',
  BAMA: 'MA_P',
  BD49: 'MA_P',
  M1: 'MA_P',
  '9C': 'SA_P',
  B413: 'SA_P',
  B904: 'SA_P',
  B953: 'SA_P',
  BAZA: 'SA_P',
  BV: 'SA_P',
  JZ: 'SA_P',
  ZB: 'SA_P',
  B970: 'AO_P',
  BD88: 'US_P',
  B679: 'US_P',
  B678: 'US_P',
  BD95: 'ET_P',
  B490: 'B490_P',
  BD89: 'B490_P',
  B695: 'US_P',
  B103: 'KE_P',
  B589: 'KE_P',
  B945: 'KE_P',
  BAKE: 'KE_P',
  BC17: 'KE_P',
  BD54: 'KE_P',
  B757: 'MU_P',
  BC64: 'MU_P',
  BC97: 'MZ_P',
  B104: 'NG_P',
  B902: 'NG_P',
  B905: 'NG_P',
  B961: 'NG_P',
  BANG: 'NG_P',
  BC52: 'RW_P',
  B969: 'SN_P',
  BASN: 'SN_P',
  B998: 'TU_P',
  B680: 'TZ_P',
  BG02: 'UG_P',
  B197: 'B0_P',
  BABH: 'B0_P',
  BD38: 'B0_P',
  DY: 'B0_P',
  GP: 'B0_P',
  B427: 'CN_P',
  B563: 'CN_P',
  BACN: 'CN_P',
  BD70: 'CN_P',
  BD72: 'CN_P',
  BD84: 'CN_P',
  '8A': 'CN_P',
  '8C': 'CN_P',
  '8D': 'CN_P',
  '8O': 'CN_P',
  '8V': 'CN_P',
  '8W': 'CN_P',
  FX: 'CN_P',
  G8: 'CN_P',
  GV: 'CN_P',
  L8: 'CN_P',
  NX: 'CN_P',
  V8: 'CN_P',
  VB: 'CN_P',
  VC: 'CN_P',
  B167: 'RC_P',
  '8F': 'CN_P',
  '8N': 'CN_P',
  '8B': 'CN_P',
  '8E': 'CN_P',
  '8G': 'CN_P',
  '8H': 'CN_P',
  '8J': 'CN_P',
  '8K': 'CN_P',
  '8L': 'CN_P',
  '8M': 'CN_P',
  '8T': 'CN_P',
  '8X': 'CN_P',
  '8Y': 'CN_P',
  B431: 'CN_P',
  B8: 'CN_P',
  D8: 'CN_P',
  E8: 'CN_P',
  FV: 'CN_P',
  H8: 'CN_P',
  J8: 'CN_P',
  LW: 'CN_P',
  M8: 'CN_P',
  N8: 'CN_P',
  R8: 'CN_P',
  W8: 'CN_P',
  Y8: 'CN_P',
  Z8: 'CN_P',
  '8P': 'CN_P',
  '8Q': 'CN_P',
  '8R': 'CN_P',
  '8S': 'CN_P',
  B569: 'CN_P',
  B570: 'CN_P',
  B571: 'CN_P',
  B572: 'CN_P',
  B574: 'CN_P',
  BC19: 'CN_P',
  BC20: 'CN_P',
  BC21: 'CN_P',
  FW: 'CN_P',
  BC11: 'CN_P',
  BC12: 'CN_P',
  BC13: 'CN_P',
  BC14: 'CN_P',
  BC15: 'CN_P',
  BAJO: 'JO_P',
  B113: 'LT_P',
  B143: 'LT_P',
  B824: 'LT_P',
  HL: 'LT_P',
  LT: 'LT_P',
  MZ: 'LT_P',
  NQ: 'LT_P',
  QD: 'LT_P',
  '7G': 'HK_P',
  '7J': 'HK_P',
  '8I': 'HK_P',
  B182: 'HK_P',
  BAHK: 'HK_P',
  BD71: 'HK_P',
  EH: 'HK_P',
  HS: 'HK_P',
  HW: 'HK_P',
  JG: 'HK_P',
  PN: 'HK_P',
  B439: 'I0_P',
  B815: 'I0_P',
  B966: 'I0_P',
  BAID: 'I0_P',
  BD85: 'I0_P',
  DX: 'I0_P',
  B420: 'IL_P',
  BAIL: 'IL_P',
  BD48: 'IL_P',
  ED: 'IL_P',
  EF: 'IL_P',
  GR: 'IL_P',
  JQ: 'IL_P',
  M3: 'IL_P',
  M9: 'IL_P',
  UG: 'IL_P',
  B142: 'IN_P',
  BAIN: 'IN_P',
  BC99: 'IN_P',
  BG12: 'IN_P',
  BG56: 'IN_P',
  EI: 'IN_P',
  R3: 'IN_P',
  '3G': 'IN_P',
  '4P': 'IN_P',
  B300: 'IN_P',
  BG01: 'IN_P',
  DD: 'IN_P',
  EN: 'IN_P',
  EQ: 'IN_P',
  MV: 'IN_P',
  NR: 'IN_P',
  XI: 'IN_P',
  VE: 'VE_P',
  B311: 'IN_P',
  GO: 'IN_P',
  GT: 'IN_P',
  IP: 'IN_P',
  L0: 'IN_P',
  OB: 'IN_P',
  '7O': 'IN_P',
  '9O': 'IN_P',
  '9X': 'IN_P',
  '9Z': 'IN_P',
  B322: 'IN_P',
  B323: 'IN_P',
  B324: 'IN_P',
  B325: 'IN_P',
  B346: 'IN_P',
  B347: 'IN_P',
  B348: 'IN_P',
  B349: 'IN_P',
  B350: 'IN_P',
  B351: 'IN_P',
  B352: 'IN_P',
  B353: 'IN_P',
  B354: 'IN_P',
  B355: 'IN_P',
  B356: 'IN_P',
  B357: 'IN_P',
  B358: 'IN_P',
  BG37: 'IN_P',
  I7: 'IN_P',
  I8: 'IN_P',
  IG: 'IN_P',
  IH: 'IN_P',
  IJ: 'IN_P',
  IK: 'IN_P',
  J0: 'IN_P',
  KF: 'IN_P',
  OD: 'IN_P',
  PB: 'IN_P',
  PP: 'IN_P',
  QO: 'IN_P',
  R0: 'IN_P',
  TO: 'IN_P',
  WB: 'IN_P',
  BG24: 'IN_P',
  E9: 'IN_P',
  I1: 'IN_P',
  IF: 'IN_P',
  M0: 'IN_P',
  O2: 'IN_P',
  OC: 'IN_P',
  P0: 'IN_P',
  PD: 'IN_P',
  PF: 'IN_P',
  PG: 'IN_P',
  QI: 'IN_P',
  RI: 'IN_P',
  Y2: 'IN_P',
  B326: 'IN_P',
  B327: 'IN_P',
  B328: 'IN_P',
  B329: 'IN_P',
  B330: 'IN_P',
  B331: 'IN_P',
  B332: 'IN_P',
  B333: 'IN_P',
  B334: 'IN_P',
  B335: 'IN_P',
  B336: 'IN_P',
  BG36: 'IN_P',
  BG39: 'IN_P',
  H1: 'IN_P',
  H3: 'IN_P',
  H4: 'IN_P',
  H5: 'IN_P',
  H6: 'IN_P',
  H7: 'IN_P',
  H9: 'IN_P',
  I5: 'IN_P',
  I6: 'IN_P',
  I9: 'IN_P',
  L9: 'IN_P',
  QW: 'IN_P',
  QY: 'IN_P',
  QZ: 'IN_P',
  RH: 'IN_P',
  RJ: 'IN_P',
  RK: 'IN_P',
  RP: 'IN_P',
  SD: 'IN_P',
  TG: 'IN_P',
  '4J': 'IN_P',
  '4K': 'IN_P',
  '4O': 'IN_P',
  '5Y': 'IN_P',
  B304: 'IN_P',
  B381: 'IN_P',
  B383: 'IN_P',
  BC55: 'IN_P',
  BC70: 'IN_P',
  BG44: 'IN_P',
  '3A': 'IN_P',
  '9A': 'IN_P',
  '9B': 'IN_P',
  B301: 'IN_P',
  B302: 'IN_P',
  B303: 'IN_P',
  B307: 'IN_P',
  B308: 'IN_P',
  B309: 'IN_P',
  B310: 'IN_P',
  B320: 'IN_P',
  B321: 'IN_P',
  B359: 'IN_P',
  B384: 'IN_P',
  B811: 'IN_P',
  BD31: 'IN_P',
  BD39: 'IN_P',
  BF: 'IN_P',
  BG23: 'IN_P',
  BG57: 'IN_P',
  BO: 'IN_P',
  H0: 'IN_P',
  N0: 'IN_P',
  O4: 'IN_P',
  PM: 'IN_P',
  VK: 'IN_P',
  B686: 'IN_P',
  BG25: 'IN_P',
  B337: 'OI_P',
  NN: 'OI_P',
  OO: 'OI_P',
  B318: 'IN_P',
  B319: 'IN_P',
  B748: 'IN_P',
  B749: 'IN_P',
  BG31: 'IN_P',
  BG33: 'IN_P',
  BG40: 'IN_P',
  HP: 'IN_P',
  OK: 'IN_P',
  OP: 'IN_P',
  OT: 'IN_P',
  OW: 'IN_P',
  OY: 'IN_P',
  S0: 'IN_P',
  T0: 'IN_P',
  TI: 'IN_P',
  V0: 'IN_P',
  W0: 'IN_P',
  Y0: 'IN_P',
  Z0: 'IN_P',
  B391: 'IN_P',
  B392: 'IN_P',
  BC10: 'IN_P',
  BD51: 'IN_P',
  BG27: 'IN_P',
  '4Z': 'IN_P',
  BD32: 'IN_P',
  BG34: 'IN_P',
  VD: 'IN_P',
  VF: 'IN_P',
  VJ: 'IN_P',
  B959: 'IN_P',
  BC62: 'IN_P',
  BC63: 'IN_P',
  BC84: 'IN_P',
  BD50: 'IN_P',
  BD56: 'IN_P',
  BD62: 'IN_P',
  BD63: 'IN_P',
  BG06: 'IN_P',
  BG07: 'IN_P',
  BG08: 'IN_P',
  BG09: 'IN_P',
  BG10: 'IN_P',
  BG26: 'IN_P',
  B313: 'IN_P',
  B314: 'IN_P',
  B315: 'IN_P',
  B316: 'IN_P',
  B317: 'IN_P',
  B360: 'IN_P',
  B361: 'IN_P',
  B362: 'IN_P',
  B363: 'IN_P',
  B364: 'IN_P',
  B365: 'IN_P',
  B366: 'IN_P',
  B367: 'IN_P',
  BG11: 'IN_P',
  BG43: 'IN_P',
  BG45: 'IN_P',
  FN: 'IN_P',
  GN: 'IN_P',
  OL: 'IN_P',
  OQ: 'IN_P',
  SI: 'IN_P',
  XP: 'IN_P',
  B305: 'IN_P',
  B306: 'IN_P',
  B382: 'IN_P',
  BD33: 'IN_P',
  BG46: 'IN_P',
  B975: 'IN_P',
  B981: 'IN_P',
  B982: 'IN_P',
  B983: 'IN_P',
  B984: 'IN_P',
  B985: 'IN_P',
  B988: 'IN_P',
  B989: 'IN_P',
  B990: 'IN_P',
  B991: 'IN_P',
  B992: 'IN_P',
  B993: 'IN_P',
  BG35: 'IN_P',
  I4: 'IN_P',
  N4: 'IN_P',
  AO: 'IN_P',
  B1: 'IN_P',
  B368: 'IN_P',
  B369: 'IN_P',
  B370: 'IN_P',
  B371: 'IN_P',
  B372: 'IN_P',
  B373: 'IN_P',
  B374: 'IN_P',
  B375: 'IN_P',
  B376: 'IN_P',
  B377: 'IN_P',
  B378: 'IN_P',
  B379: 'IN_P',
  B380: 'IN_P',
  D0: 'IN_P',
  I2: 'IN_P',
  I3: 'IN_P',
  N2: 'IN_P',
  N3: 'IN_P',
  N5: 'IN_P',
  N6: 'IN_P',
  N7: 'IN_P',
  N9: 'IN_P',
  NG: 'IN_P',
  NP: 'IN_P',
  NT: 'IN_P',
  O5: 'IN_P',
  O6: 'IN_P',
  O7: 'IN_P',
  O8: 'IN_P',
  Q0: 'IN_P',
  ZT: 'IN_P',
  ZV: 'IN_P',
  ZW: 'IN_P',
  ZX: 'IN_P',
  NA37: 'IN_P',
  NA01: 'IN_P',
  NA02: 'IN_P',
  NA03: 'IN_P',
  NA04: 'IN_P',
  NA05: 'IN_P',
  NA06: 'IN_P',
  NA07: 'IN_P',
  NA08: 'IN_P',
  NA09: 'IN_P',
  NA10: 'IN_P',
  NA11: 'IN_P',
  NA12: 'IN_P',
  NA13: 'IN_P',
  NA14: 'IN_P',
  NA15: 'IN_P',
  NA16: 'IN_P',
  NA17: 'IN_P',
  NA18: 'IN_P',
  NA19: 'IN_P',
  NA20: 'IN_P',
  NA21: 'IN_P',
  NA22: 'IN_P',
  NA23: 'IN_P',
  NA24: 'IN_P',
  NA25: 'IN_P',
  NA26: 'IN_P',
  NA27: 'IN_P',
  NA28: 'IN_P',
  NA29: 'IN_P',
  NA30: 'IN_P',
  NA31: 'IN_P',
  NA32: 'IN_P',
  NA33: 'IN_P',
  NA34: 'IN_P',
  NA35: 'IN_P',
  NA36: 'IN_P',
  NB37: 'IN_P',
  NB01: 'IN_P',
  NB02: 'IN_P',
  NB03: 'IN_P',
  NB04: 'IN_P',
  NB05: 'IN_P',
  NB06: 'IN_P',
  NB07: 'IN_P',
  NB08: 'IN_P',
  NB09: 'IN_P',
  NB10: 'IN_P',
  NB11: 'IN_P',
  NB12: 'IN_P',
  NB13: 'IN_P',
  NB14: 'IN_P',
  NB15: 'IN_P',
  NB16: 'IN_P',
  NB17: 'IN_P',
  NB18: 'IN_P',
  NB19: 'IN_P',
  NB20: 'IN_P',
  NB21: 'IN_P',
  NB22: 'IN_P',
  NB23: 'IN_P',
  NB24: 'IN_P',
  NB25: 'IN_P',
  NB26: 'IN_P',
  NB27: 'IN_P',
  NB28: 'IN_P',
  NB29: 'IN_P',
  NB30: 'IN_P',
  NB31: 'IN_P',
  NB32: 'IN_P',
  NB33: 'IN_P',
  NB34: 'IN_P',
  NB35: 'IN_P',
  NB36: 'IN_P',
  Y4: 'IN_P',
  '1O': 'IN_P',
  BS: 'IN_P',
  C0: 'IN_P',
  F0: 'IN_P',
  G0: 'IN_P',
  IO: 'IN_P',
  IW: 'IN_P',
  JO: 'IN_P',
  KI: 'IN_P',
  KO: 'IN_P',
  LO: 'IN_P',
  MI: 'IN_P',
  MO: 'IN_P',
  OF: 'IN_P',
  OJ: 'IN_P',
  VP: 'IN_P',
  Y3: 'IN_P',
  Y5: 'IN_P',
  Y6: 'IN_P',
  Y7: 'IN_P',
  I501: 'IN_P',
  I601: 'IN_P',
  I602: 'IN_P',
  I603: 'IN_P',
  I604: 'IN_P',
  I605: 'IN_P',
  I101: 'IN_P',
  I201: 'IN_P',
  I301: 'IN_P',
  I401: 'IN_P',
  B144: 'HM_P',
  B613: 'HM_P',
  B634: 'HM_P',
  B826: 'HM_P',
  BAKW: 'HM_P',
  HM: 'HM_P',
  '4Q': 'JP_P',
  '60': 'JP_P',
  '61': 'JP_P',
  '62': 'JP_P',
  '63': 'JP_P',
  '65': 'JP_P',
  '6A': 'JP_P',
  '6B': 'JP_P',
  '6C': 'JP_P',
  '6G': 'JP_P',
  '6H': 'JP_P',
  '6I': 'JP_P',
  '7E': 'JP_P',
  B872: 'JP_P',
  BAJP: 'JP_P',
  BD73: 'JP_P',
  BG28: 'JP_P',
  DG: 'JP_P',
  EJ: 'JP_P',
  JE: 'JP_P',
  R6: 'JP_P',
  RT: 'JP_P',
  XE: 'JP_P',
  QK: 'TWJP_P',
  B743: 'ADKRW_P',
  '4E': 'KR_P',
  B644: 'KR_P',
  B645: 'KR_P',
  B666: 'KR_P',
  B668: 'KR_P',
  B692: 'KR_P',
  BAKR: 'KR_P',
  BC75: 'KR_P',
  KA: 'KR_P',
  KB: 'KR_P',
  ZK: 'KR_P',
  QL: 'TWKRW_P',
  B415: 'ML_P',
  BAMY: 'ML_P',
  BC83: 'ML_P',
  BD58: 'ML_P',
  BW: 'ML_P',
  ML: 'ML_P',
  B828: 'LB_P',
  BALB: 'LB_P',
  LB: 'LB_P',
  B833: 'HN_P',
  B944: 'HN_P',
  BAQA: 'HN_P',
  HN: 'HN_P',
  B830: 'OM_P',
  BAOM: 'OM_P',
  BD99: 'OM_P',
  KC: 'OM_P',
  B170: 'LY_P',
  B447: 'LY_P',
  B448: 'LY_P',
  B449: 'LY_P',
  B450: 'LY_P',
  B834: 'LY_P',
  LA: 'LY_P',
  LY: 'LY_P',
  NF: 'LY_P',
  NH: 'LY_P',
  NW: 'LY_P',
  NY: 'LY_P',
  BASA: 'QR_P',
  BD64: 'QR_P',
  GW: 'QR_P',
  QR: 'QR_P',
  B467: 'PH_P',
  B776: 'PH_P',
  B965: 'PH_P',
  BAPH: 'PH_P',
  J3: 'PH_P',
  B141: 'PH_P',
  B565: 'PH_P',
  B856: 'PH_P',
  CW: 'PH_P',
  '9T': '9T_P',
  AP: '9T_P',
  AQ: '9T_P',
  B745: '9T_P',
  BASG: '9T_P',
  BC74: '9T_P',
  BD40: '9T_P',
  MJ: '9T_P',
  ZS: '9T_P',
  B422: 'TWSG_P',
  B386: 'US_P',
  '1I': 'TH_P',
  '1J': 'TH_P',
  B814: 'TH_P',
  B964: 'TH_P',
  BATH: 'TH_P',
  BC22: 'TH_P',
  LK: 'TH_P',
  TM: 'TH_P',
  B162: 'RT_P',
  '4G': 'TN_P',
  B412: 'TN_P',
  B583: 'TN_P',
  BATN: 'TN_P',
  BATW: 'TN_P',
  BC38: 'TN_P',
  QM: 'TWTA_P',
  BC92: 'US_P',
  B199: 'BD_P',
  B900: 'BD_P',
  BABD: 'BD_P',
  B676: 'US_P',
  BAKH: 'US_P',
  B614: 'KZ_P',
  B842: 'KZ_P',
  BAKZ: 'KZ_P',
  BG16: 'KZ_P',
  B430: 'LK_P',
  B859: 'LK_P',
  BALK: 'LK_P',
  BC94: 'US_P',
  B180: 'PK_P',
  B831: 'PK_P',
  BAPK: 'PK_P',
  BC93: 'US_P',
  B446: 'LQ_P',
  B621: 'LQ_P',
  BALQ: 'LQ_P',
  BC16: 'LQ_P',
  KK: 'LQ_P',
  KL: 'LQ_P',
  KT: 'LQ_P',
  KU: 'LQ_P',
  KZ: 'LQ_P',
  LQ: 'LQ_P',
  LR: 'LQ_P',
  LZ: 'LQ_P',
  MQ: 'LQ_P',
  ND: 'LQ_P',
  NK: 'LQ_P',
  NM: 'LQ_P',
  QE: 'LQ_P',
  QF: 'LQ_P',
  QG: 'LQ_P'
};

/**
 * Reverse mapping from Planning Company to Company Code
 * Maps planning company codes (e.g., US_P) to company codes (e.g., 01)
 */
export const PLANNING_COMPANY_TO_COMPANY_MAPPING: Record<string, string> = {
  MN_P: 'BC94',
  B491_P: 'B817',
  V1_P: 'V1',
  ADKRW_P: 'B743',
  ADEGP_P: 'NB',
  RC_P: 'B167',
  OM2_P: 'BD30',
  BO_P: 'BC76',
  IR_P: '9E',
  RU_P: '5I',
  WE_P: 'WE',
  K6_P: 'K6',
  AR_P: 'G1',
  RK_P: 'B159',
  TWIT_P: 'B573',
  '4C_P': 'BACH',
  RN_P: 'B160',
  '9T_P': 'BASG',
  G7_P: 'G7',
  LV_P: 'BALV',
  '7H_P': '7H',
  DK_P: 'BADK',
  CA_P: '5Z',
  TWMX_P: 'B437',
  TW_P: 'W1',
  TWFR_P: 'B421',
  C2_P: 'C2',
  DZ_P: 'B678',
  EO_P: 'BACL',
  '2P_P': '2P',
  TWDE_P: 'GX',
  EG_P: '67',
  TWPLN_P: 'B599',
  HR_P: 'B858',
  J9_P: 'J9',
  MA_P: 'M1',
  IN_P: '3A',
  BD_P: 'BABD',
  J6_P: 'J6',
  FI_P: '1H',
  HN_P: 'BAQA',
  WK_P: 'B273',
  ZXUK_P: 'B276',
  '03_P': '03',
  TWUS_P: 'DJ',
  QU_P: '1X',
  BE_P: '88',
  M4_P: 'BB66',
  TZ_P: 'B680',
  DE_P: '4D',
  ES_P: '47',
  '3V_P': '3V',
  KZ_P: 'B842',
  V7_P: 'V7',
  ZXUS_P: 'B275',
  '5K_P': '5K',
  JM_P: 'BC85',
  K9_P: '6T',
  TR_P: 'BATR',
  TWSG_P: 'B422',
  '2Q_P': '2Q',
  B118_P: 'B118',
  AT_P: 'BAAT',
  K5_P: 'K5',
  SE_P: '1A',
  NO_P: 'BANO',
  EZ_P: 'EZ',
  '3C_P': '3C',
  '5J_P': '5J',
  '9P_P': '9P',
  Z7_P: 'Z7',
  KR_P: 'KB',
  HM_P: 'BAKW',
  '7K_P': '7K',
  VE_P: 'VE',
  P7_P: 'P7',
  BA_P: '7W',
  SN_P: 'BASN',
  IL_P: 'ED',
  RW_P: 'BC52',
  Z4_P: 'BANZ',
  RT_P: 'B162',
  '6Y_P': '6Y',
  UY_P: 'B758',
  TWJP_P: 'QK',
  GR_P: 'B957',
  DO_P: 'B818',
  OI_P: 'OO',
  ADSCA_P: 'CQ',
  PT_P: 'BAPT',
  HQ_P: 'HQ',
  UZ_P: 'BC93',
  WU_P: 'B200',
  BW_P: 'BD88',
  C1_P: 'C1',
  M2_P: 'BB01',
  LK_P: 'BALK',
  ET_P: 'BD95',
  JO_P: 'BAJO',
  PA_P: 'BAPA',
  CI_P: 'B679',
  SK_P: '6K',
  GE_P: 'B841',
  Z5_P: 'Z5',
  F7_P: 'F7',
  LT_P: 'LT',
  AC_P: 'BC18',
  '93_P': '93',
  B490_P: 'BD89',
  IM_P: '42',
  HU_P: 'BAHU',
  PP_P: 'B187',
  TWAUD_P: 'B436',
  TB_P: 'C3',
  VN_P: 'BAVN',
  RA_P: 'B158',
  TWTA_P: 'QM',
  TH_P: '1I',
  M8_P: 'BB95',
  AF_P: 'B797',
  WC_P: 'B270',
  MT_P: 'BG42',
  EY_P: 'EY',
  V5_P: 'V5',
  TWUK_P: 'TU',
  EU_P: 'BALU',
  MU_P: 'B757',
  LP_P: 'BAPE',
  ML_P: 'B415',
  '7T_P': '7T',
  TF_P: '3T',
  M6_P: 'BB70',
  I0_P: 'BAID',
  K1_P: 'K1',
  RO_P: '9R',
  U0_P: 'HB',
  PK_P: 'B831',
  '9S_P': '9S',
  SZ_P: '6P',
  '4T_P': '4T',
  '9M_P': '9M',
  UA_P: 'B843',
  AU_P: 'BAAU',
  NP_P: 'BG71',
  KH_P: 'B676',
  '2W_P': '2W',
  PL_P: 'P3',
  V3_P: 'V3',
  ZXAU_P: 'B279',
  EX_P: 'EX',
  BR_P: 'BABR',
  LY_P: 'LY',
  ZE_P: 'ZE',
  ZXDE_P: 'B277',
  AM_P: 'BG51',
  TWKRW_P: 'QL',
  J4_P: 'J4',
  LQ_P: 'LQ',
  B492_P: 'B838',
  F4_P: 'F4',
  LB_P: 'BALB',
  M7_P: 'BB93',
  TWES_P: 'B598',
  PH_P: 'CW',
  FR_P: '46',
  V6_P: 'V6',
  LN_P: 'LN',
  B489_P: 'B489',
  Z1_P: 'Z1',
  F3_P: 'F3',
  '9Q_P': '9N',
  TWLX_P: 'GZ',
  NL_P: 'B425',
  BG_P: '1B',
  HK_P: '8I',
  OM_P: 'BAOM',
  '5L_P': '5L',
  SA_P: '9C',
  MX_P: '4I',
  OM1_P: 'BD01',
  IT_P: 'F9',
  EC_P: 'B453',
  QR_P: 'BASA',
  JP_P: '4Q',
  KE_P: 'BD54',
  MG_P: 'BG20',
  D4_P: 'D4',
  UG_P: 'BG02',
  VO_P: 'VO',
  CN_P: '8R',
  M3_P: 'BB32',
  NG_P: 'B905',
  AO_P: 'B970',
  '2K_P': '2K',
  GT_P: 'B823',
  E5_P: 'E5',
  M1_P: 'BB98',
  US_P: '01',
  V2_P: 'V2',
  M5_P: 'BB41',
  K8_P: '6R',
  '9W_P': '9J',
  KV_P: 'D3',
  P1_P: 'EP',
  '5C_P': '5C',
  '9K_P': '9K',
  OR_P: 'BARS',
  TU_P: 'B998',
  TTIS_P: 'BAIS',
  '7C_P': '7C',
  B0_P: 'B197',
  TN_P: 'B412',
  CG_P: 'BG04',
  UK_P: '3U',
  CZ_P: '64',
  CO_P: 'B115',
  RB_P: 'B161',
  PY_P: 'BC96',
  AA_P: 'B102',
  MZ_P: 'BC97',
  SI_P: 'B837'
};

/**
 * Gets the Company code for a given Planning Company code
 * @param planningCompanyCode The planning company code to look up
 * @returns The company code, or the original planning company code if not found
 */
export const getCompanyCode = (planningCompanyCode: string | null | undefined): string => {
  if (!planningCompanyCode) return '';
  return PLANNING_COMPANY_TO_COMPANY_MAPPING[planningCompanyCode] || planningCompanyCode;
};

/**
 * Gets the Planning Company code for a given Company code
 * @param companyCode The company code to look up
 * @returns The planning company code, or the original company code if not found
 */
export const getPlanningCompanyCode = (companyCode: string | null | undefined): string => {
  if (!companyCode) return '';
  return COMPANY_TO_PLANNING_COMPANY_MAPPING[companyCode] || companyCode;
};
